var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoKaiperDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 553.43 165.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .logo_kaiper_default-1 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "343.27 48.59 343.27 117.14 407.59 117.14 407.59 101.44 361.5 101.44 361.5 64.29 407.59 64.29 407.59 48.59 343.27 48.59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.61,
    y: 75.23,
    width: 36.98,
    height: 15.27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.27,
    y: 48.59,
    width: 18.23,
    height: 68.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.05,
    y: 48.59,
    width: 18.23,
    height: 68.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.74,48.59h-28.23l-29.32,68.54h20.16l5.62-13.89h35.32l5.62,13.89h20.16l-29.32-68.54ZM181.33,63.82l9.92,24.55h-23.27l9.93-24.55h3.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.16 117.14 106.27 117.14 80.23 87.2 105.51 87.2 132.16 117.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.16 48.59 106.27 48.59 80.23 78.53 105.51 78.53 132.16 48.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.38,117.14l-17.08-24.13c8.65-3.29,14.8-11.65,14.8-21.46,0-12.68-10.28-22.96-22.96-22.96h-47.82v68.54h18.23v-22.63h18l14.9,22.63h21.93ZM439.56,64.64h26.67c4.22,0,7.64,3.42,7.64,7.64s-3.42,7.64-7.64,7.64h-26.67v-15.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5,48.59v68.54h18.23v-21.28h28.92c13.05,0,23.63-10.58,23.63-23.63h0c0-13.05-10.58-23.63-23.63-23.63h-47.15ZM280.74,79.82v-15.18h26.73c4.19,0,7.59,3.4,7.59,7.59s-3.4,7.59-7.59,7.59h-26.73Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_default-1",
    width: 553.43,
    height: 165.73
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKaiperDefault);
export default __webpack_public_path__ + "static/media/logo_kaiper_default.00081c36da864bec6970d0ff74946b4f.svg";
export { ForwardRef as ReactComponent };